import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Typography, Button } from '@material-ui/core';
import Paper from '@mui/material/Paper';
export default function RecentTransactionsForm(props: any) {
  const { sortedTransaction, handleKnowMore } = props;
  const Item = styled(Paper)(({ theme }: any) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  return (
    <>
      {sortedTransaction &&
        sortedTransaction?.length > 0 &&
        sortedTransaction.map((item: any) => {
          return (
            <>
              <Box className='portfoliBottomBox'>
                <div className='row-one'>
                  <div className='rupee'>
                    ₹{' '}
                    {item.amount
                      .toFixed(0)
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                  </div>
                  <div className='price'></div>
                  <div className='date'>{item.transaction_date}</div>
                </div>
                <div className='row-one'>
                  <div className='invested'>{item.transaction_type}</div>
                  <div className='success'>
                    <span>{'transaction id'}</span> -{' '}
                    <span>{item.transaction_id}</span>
                  </div>
                </div>
              </Box>
            </>
          );
        })}
      {sortedTransaction?.length > 0 ? (
        <Box className='recTransBtn'>
          <Button
            onClick={handleKnowMore}
            variant='contained'
            className='btnWhite'
          >
            know more
          </Button>
        </Box>
      ) : (
        <div className='text-center text-blue fs-24 fw-400 line-normal'>
          No data found
        </div>
      )}
    </>
  );
}
